export * as Tooltip from './styled/tooltip'
